export const REQUIRED_ALTERNATE_NAMES_FIELDS = ['firstName', 'lastName'];

export const DEBOUNCE_DELAY_MS = 200;
